import { Link } from "react-router-dom";
import type { PayoutView } from "@/services/types";
import { Badge } from "@/components/base/Badge";
import { Button } from "@/components/base/Button";

export function WinnerPanel({ payout }: { payout: PayoutView }) {
  const hasBank = Boolean(payout.bankAccountName);
  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <div className="border-b border-background-100 px-4 py-3">
        <h3 className="flex items-center gap-1.5 text-sm font-semibold text-foreground-900">
          <i className="ri-user-star-line text-primary-600" />
          Winner
        </h3>
      </div>
      <div className="p-4">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div>
            <div className="flex flex-wrap items-center gap-2">
              <p className="text-lg font-semibold text-foreground-950">{payout.winnerName}</p>
              {payout.isOrganizer ? <Badge color="accent" dot>Organizer</Badge> : null}
            </div>
            <p className="tnum mt-0.5 text-sm text-foreground-500">
              {payout.winnerCode} · Ticket {payout.winnerTicketNumber}
            </p>
          </div>
          <Link to={`/members/${payout.winnerMemberId}`}>
            <Button variant="outline" size="sm" icon={<i className="ri-user-3-line" />}>
              View profile
            </Button>
          </Link>
        </div>
        <dl className="mt-3 grid grid-cols-2 gap-3 text-sm sm:grid-cols-3">
          <div>
            <dt className="text-xs text-foreground-500">Phone</dt>
            <dd className="tnum mt-0.5 font-medium text-foreground-900">{payout.winnerPhone}</dd>
          </div>
          <div>
            <dt className="text-xs text-foreground-500">City</dt>
            <dd className="mt-0.5 font-medium text-foreground-900">{payout.winnerCity}</dd>
          </div>
          <div>
            <dt className="text-xs text-foreground-500">Bank details</dt>
            <dd className="tnum mt-0.5 font-medium text-foreground-900">
              {hasBank ? payout.bankAccountName : <span className="text-foreground-400">Not recorded</span>}
            </dd>
          </div>
          {payout.ifsc ? (
            <div className="col-span-2 sm:col-span-3">
              <dt className="text-xs text-foreground-500">IFSC</dt>
              <dd className="tnum mt-0.5 font-medium text-foreground-900">{payout.ifsc}</dd>
            </div>
          ) : null}
        </dl>
      </div>
    </div>
  );
}